// extracted by mini-css-extract-plugin
export default {"text":"styles_text__HdOPR","inputField":"styles_inputField__JvLaA","input":"styles_input__tGBSi"};